import ServiceWrapper, { type ServiceOptions } from "@utils/ServiceWrapper";
import { LOCATION_SEARCHABLE_READ } from "@const/LocationConst";

interface LocationDaoOptions {
    action: string;
    params?: unknown;
    signal?: AbortSignal;
}

/**
 * Data Access Object for the Location API.
 */
const LocationDao = <T = unknown>(options: LocationDaoOptions): Promise<{ data: T }> | null => {
    const { action, params, signal } = options;

    const requestOptions: ServiceOptions = { url: "", method: "GET", signal };

    const actionConfig: Record<string, Partial<ServiceOptions>> = {
        locationsSearchableRead: { method: "GET", params: params ?? undefined, url: LOCATION_SEARCHABLE_READ }
    };

    const config = actionConfig[action];
    if (!config) {
        const error = new Error(`LocationDao: Invalid action "${action}" provided`);
        console.error("LocationDao: Invalid action provided");
        throw error;
    }

    return ServiceWrapper.serviceCall({
        options: { ...requestOptions, ...config }
    }) as Promise<{ data: T }>;
};

export default LocationDao;
